import {useCallback, useRef} from 'react';
import {twMerge} from '../../../common/twMerge';
import {Text} from '../../atoms/Text/Text';
import {FileFieldV2Props} from './FileFieldV2Props.interface';

export function FileFieldV2({
  disabled,
  status,
  placeholder,
  addButtonLabel,
  className,
  ...props
}: FileFieldV2Props) {
  const ref = useRef<HTMLInputElement | null>(null);
  const onClick = useCallback(() => {
    ref.current?.click();
  }, []);

  return (
    <div
      className={twMerge(
        'flex h-48pxr w-full items-center rounded-8pxr border-1 border-solid border-theme-transparent-30 px-18pxr justify-between cursor-pointer',
        status === 'error' &&
          'border-static-point-red bg-[rgb(var(--colors-static-point-red)_/_5%)]',
        disabled && 'border-theme-transparent-20 cursor-not-allowed'
      )}
      onClick={onClick}
    >
      <input
        ref={ref}
        type="file"
        disabled={disabled}
        className={twMerge('hidden', className)}
        value={props.value}
        {...props}
      />
      <Text
        className={twMerge(
          'font-medium2 text-theme-solid-100',
          disabled && 'text-theme-solid-20'
        )}
      >
        {placeholder}
      </Text>
      {/* TODO: 신규 버튼 컴포넌트로 교체 */}
      <button
        type="button"
        disabled={disabled}
        className="whitespace-nowrap h-28pxr rounded-100pxr px-12pxr bg-theme-solid-100 text-theme-solid-0 border-theme-transparent-30 font-small2-bold disabled:border-theme-transparent-30 disabled:bg-theme-solid-20 disabled:text-theme-solid-10 disabled:cursor-not-allowed"
      >
        {addButtonLabel}
      </button>
    </div>
  );
}
